import type { QuantityKind } from "../utils/formatQuantityValue";
import type {
  VisualDiffKind,
  VisualDiffMarker,
  VisualDiffRoute,
  VisualDiffStatus,
  VisualDiffTypeEntry,
} from "../utils/computeVisualDiff";
import type { DiffNavigationTarget } from "./types";

// Hex twins of QuantitiesTab's STATUS_DOT_CLASS so both tabs speak one color language.
export const STATUS_RGB: Record<VisualDiffStatus, [number, number, number]> = {
  added: [34, 197, 94],
  removed: [239, 68, 68],
  changed: [245, 158, 11],
  unchanged: [209, 213, 219],
};

export const ALL_STATUSES: VisualDiffStatus[] = [
  "added",
  "removed",
  "changed",
  "unchanged",
];

export const KIND_TO_QUANTITY_KIND: Record<VisualDiffKind, QuantityKind> = {
  elements: "elements",
  trays: "cables",
};

export const TYPE_OVERVIEW_ZOOM_PADDING_PDF_POINTS = 80;

// One item has no width of its own, so this margin alone decides how close the zoom lands.
export const SINGLE_ITEM_ZOOM_PADDING_PDF_POINTS = 140;

// Colored statuses paint after gray so a change is never hidden under an unchanged box.
export const STATUS_PAINT_ORDER: VisualDiffStatus[] = [
  "unchanged",
  "removed",
  "changed",
  "added",
];

export const EMPTY_MARKERS: VisualDiffMarker[] = [];

export const EMPTY_ROUTES: VisualDiffRoute[] = [];

export const EMPTY_NAVIGATION_TARGETS: DiffNavigationTarget[] = [];

export const EMPTY_RAIL_ENTRIES: VisualDiffTypeEntry[] = [];

export const EMPTY_STATUS_COUNTS: Record<VisualDiffStatus, number> = {
  added: 0,
  removed: 0,
  changed: 0,
  unchanged: 0,
};
